/**
 * 28 spec タイポグラフィ階層 + アイコンサイズ + 重み
 *
 * 一次情報: hub/log/28.../03_ui_implementation_spec.md §3.2 (type scale) / §8.1 (icon size)
 * 移植元: nasu-patient-app-front/src/shared/styles/typography.ts
 * (文字サイズ拡大モードは本アプリでは未導入。必要になったら nasu 実装を移植する)
 */
export const FONT_FAMILY_SANS =
  'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Inter, "Hiragino Sans", "Yu Gothic UI", "Yu Gothic", "Noto Sans JP", sans-serif'

export const typeScale = {
  titlePage: {
    fontSize: 40,
    lineHeight: 1.2,
    fontWeight: 700,
    letterSpacing: '-0.01em',
  },
  h1: {
    fontSize: 30,
    lineHeight: 1.3,
    fontWeight: 700,
    letterSpacing: '-0.01em',
  },
  h2: {
    fontSize: 24,
    lineHeight: 1.35,
    fontWeight: 600,
    letterSpacing: '-0.01em',
  },
  h3: { fontSize: 20, lineHeight: 1.4, fontWeight: 600 },
  h4: { fontSize: 16, lineHeight: 1.5, fontWeight: 600 },
  body: { fontSize: 16, lineHeight: 1.5, fontWeight: 400 },
  bodySm: { fontSize: 14, lineHeight: 1.45, fontWeight: 400 },
  label: { fontSize: 13, lineHeight: 1.4, fontWeight: 500 },
  tag: { fontSize: 12, lineHeight: 1.3, fontWeight: 500 },
  micro: { fontSize: 11, lineHeight: 1.3, fontWeight: 500 },
} as const

/**
 * 28 spec §8.1 アイコンサイズ
 *  - UI: 14 / 16 / 18 / 20
 *  - Decorative: 22 / 24
 */
export const ICON_SIZE = {
  sm: 14,
  md: 16,
  lg: 18,
  xl: 20,
} as const

/**
 * 数字は等幅 (tabular-nums) で縦を揃える。リスト中の番号・受付番号に必須
 * (01-foundations/typography.md「等幅・数字表示」)。
 */
export const FONT_TABULAR = { fontFeatureSettings: "'tnum'" } as const

export const FONT_WEIGHT = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
} as const
